export const Footer = ({ onNavigate }) => {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#050505] border-t border-white/10 overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 pt-20 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16">
          <div className="md:col-span-6">
            <p className="text-xs uppercase tracking-[0.28em] text-[#00E5FF] font-bold mb-4">
              Leonard Technology Inc.
            </p>
            <p className="text-[#A0AEC0] max-w-sm leading-relaxed">
              The managed service partner for companies that refuse downtime.
              Resilient, secure, and quietly relentless.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="text-sm text-white font-semibold mb-4">Services</p>
            <ul className="space-y-2 text-[#A0AEC0]">
              {["Managed IT", "Cybersecurity", "Cloud", "Helpdesk", "Backup & DR"].map(
                (s) => (
                  <li key={s}>
                    <button
                      onClick={() => onNavigate?.("#services")}
                      className="hover:text-white transition-colors duration-300"
                    >
                      {s}
                    </button>
                  </li>
                )
              )}
              <li>
                <button
                  onClick={() => onNavigate?.("/process-serving")}
                  className="hover:text-white transition-colors duration-300"
                >
                  NY Process Serving
                </button>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="text-sm text-white font-semibold mb-4">Company</p>
            <ul className="space-y-2 text-[#A0AEC0]">
              <li>
                <button onClick={() => onNavigate?.("#approach")} className="hover:text-white transition-colors duration-300">Approach</button>
              </li>
              <li>
                <button onClick={() => onNavigate?.("#voices")} className="hover:text-white transition-colors duration-300">Client voices</button>
              </li>
              <li>
                <button onClick={() => onNavigate?.("#contact")} className="hover:text-white transition-colors duration-300">Contact</button>
              </li>
              <li>
                <a href="mailto:jleonard@leonardtechinc.com" className="hover:text-white transition-colors duration-300">Email us</a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/10 pt-10">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-sm text-[#5A6472]">
            <p>© {year} Leonard Technology Inc. All rights reserved.</p>
            <p>Architecting the future of IT.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};
